import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, IVehicleManagerAuditsAtLocation, VehicleAudit } from "../../../logic/api";
import styles from "../styles";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import usePaths from "../../../utility/paths";
import VehicleAuditListItem from "../../../components/lists/listItems/VehicleAuditListItem/VehicleAuditListItem";
import HeaderRow from "./condensedLayout/HeaderRow";
import AuditHistoryRow from "./condensedLayout/auditHistory/AuditHistoryRow"
import { useTranslation } from "react-i18next";
import { ReleaseFlag, useReleaseManagement } from "../../../utility/feature-management";
import { useHistory } from "react-router-dom";

const VehicleAuditsAtLocation: React.FunctionComponent<{
  isCondensedView?: boolean;
  path: string;
}> = (props) => {
  const { t } = useTranslation();
  const paths = usePaths();
  const history = useHistory();
  const [params, setParams] = useState<IVehicleManagerAuditsAtLocation>({
    path: props.path
  });
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);


  useEffect(() => {
    if (props.path != params.path) {
      setParams({
        ...params, path: props.path
      });
    }
  }, [props.path]);

  const handleOnClick = (item: VehicleAudit) => {
    if (item.id != null) {
      const auditUrl = paths.vehicleManagerViewAudit(item.id);
      if (isOpenLinksInNewTab) {
        window.open(auditUrl, "_blank");
      } else {
        history.push(auditUrl);
      }
    }
  };

  return <div>
    {props.isCondensedView ? (<PagedDataView<IVehicleManagerAuditsAtLocation, VehicleAudit>
      apiHook={api.hooks.vehicleManager.getAuditsAtLocation}
      parameters={params}
      header={() => <HeaderRow columnHeaders={[t("locations.type"), t("locations.location"), t("locations.result"), t("locations.auditedBy"), t("locations.auditedAt"), ""]} />}
      isTable
      animate={false}
      renderItem={(item: VehicleAudit, index) => {
        return <AuditHistoryRow audit={item} auditType={"Lane Audit"} rowIndex={index} onClick={() => handleOnClick(item)} />
      }}>
      <div style={styles.noData}>
        {t("locations.noAuditsFound")}
      </div>
    </PagedDataView>)
      :
      (<PagedDataView<IVehicleManagerAuditsAtLocation, VehicleAudit>
        apiHook={api.hooks.vehicleManager.getAuditsAtLocation}
        parameters={params}
        renderItem={(item) => {
          return <VehicleAuditListItem item={item} onClick={() => handleOnClick(item)} />
        }}>
        <div style={styles.noData}>
          {t("locations.noAuditsFound")}
        </div>
      </PagedDataView>)}
  </div>
};

VehicleAuditsAtLocation.propTypes = {
  path: propTypes.string.isRequired,
}

export default VehicleAuditsAtLocation;
